export enum DataHooks {
  BackButton = 'calendar-back-button',
  Tooltip = 'calendar-back-button-tooltip',
}
